import { HealerPackage } from '../../core/models/healer-package.dto';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';
import { RecommendedHealer } from '../../infra/adapters/luminara/healer-selection/dto/recomended-healer';
import { RecommendedHealers } from '../../infra/adapters/luminara/healer-selection/dto/recommended-healers';

export interface HealerSelectionState {
  isLoading: boolean;
  recommendedHealers?: RecommendedHealers;
  loadingDataError?: string;
  expiredHealerRecommendation: boolean;
  selectedHealer?: RecommendedHealer;
  selectedPackageId?: string;
  showTrainingAndQualificationsPopup: boolean;
}

export const initialHealerSelectionsState = () =>
  ({
    isLoading: true,
    expiredHealerRecommendation: false,
    showTrainingAndQualificationsPopup: false,
  } as HealerSelectionState);

export interface HealerSelectionAction {
  type:
    | 'LOAD_HEALER_RECOMMENDATION_SUCCESS'
    | 'LOAD_HEALER_RECOMMENDATION_FAILURE'
    | 'SET_RECOMMENDATION_EXPIRED'
    | 'SET_SELECTED_HEALER'
    | 'SET_SELECTED_PACKAGE_ID'
    | 'SET_LOADING'
    | 'SHOW_TRAINING_QUALIFICATIONS_POPUP'
    | 'HIDE_TRAINING_QUALIFICATIONS_POPUP';
  payload?: any;
}

const healerSelectionReducer = (state: HealerSelectionState = initialHealerSelectionsState(), action: HealerSelectionAction): HealerSelectionState => {
  switch (action.type) {
    case 'LOAD_HEALER_RECOMMENDATION_SUCCESS':
      return {
        ...state,
        recommendedHealers: action.payload,
        selectedHealer: action.payload.firstRecommendedHealer,
        isLoading: false,
        selectedPackageId: action.payload.firstRecommendedHealer?.packages?.filter((c?: HealerPackage) => c != null)?.at(0)?.id,
      };
    case 'LOAD_HEALER_RECOMMENDATION_FAILURE':
      return { ...state, loadingDataError: extractMessageFromError(action.payload), isLoading: false };
    case 'SET_RECOMMENDATION_EXPIRED':
      return { ...state, expiredHealerRecommendation: action.payload, isLoading: false, loadingDataError: undefined };
    case 'SET_SELECTED_PACKAGE_ID': {
      return { ...state, selectedPackageId: action.payload };
    }
    case 'SET_SELECTED_HEALER': {
      if (state.recommendedHealers) {
        const selectedHealer: RecommendedHealer = Object.values(state.recommendedHealers)
          .filter((it) => it != null && typeof it != 'string')
          .find((healer) => healer.id === action.payload);
        return {
          ...state,
          selectedHealer: selectedHealer,
          selectedPackageId: selectedHealer.packages?.filter((c?: HealerPackage) => c != null)?.at(0)?.id,
        };
      }
      return { ...state };
    }
    case 'SET_LOADING': {
      return { ...state, isLoading: action.payload };
    }
    case 'HIDE_TRAINING_QUALIFICATIONS_POPUP': {
      return { ...state, showTrainingAndQualificationsPopup: false };
    }
    case 'SHOW_TRAINING_QUALIFICATIONS_POPUP': {
      return { ...state, showTrainingAndQualificationsPopup: true };
    }
    default:
      return state;
  }
};

export default healerSelectionReducer;
